module.exports = __webpack_public_path__ + "img/12.c3c532c4.jpg";